const { createSlice } = require("@reduxjs/toolkit");

const appSlice = createSlice({
  name: 'app',
  initialState: {
    data: [],
  },
  reducers: {
    updateData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export default appSlice;
